import React, { Component } from 'react'
import { Table, Row, Input, message, Select } from "antd"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import getPathogen from "app/utils/pathogenDispose"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import styled from 'styled-components'
const Option = Select.Option

const RequiredStarWrapper = styled.div`
  display: flex;
  align-items: center;
  .required-star {
    color: red;
  }
`
const ObserverInput = observer(({ record, field, onChange, placeholder }) => {
  return (
    <div className="ta-c">
      <Input
        style={{ width: "95%" }}
        value={record[field]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  )
})

const ObserverRelationSelector = observer(({ record, relations, onChange }) => {
  return (
    <div className="ta-c relation-helper-wrapper">
      {record.marked && <span className="relation-helper" style={{ background: record.color }} />}
      <Select
        style={{ width: "75%" }}
        placeholder="请选择关系"
        value={record.relationName}
        onChange={onChange}>
        {relations.slice().map(relation => <Option key={relation.id}>{relation.name}</Option>)}
      </Select>
    </div>
  )
})

const ObserverPathogenSelector = observer(({ record, onChange }) => {
  const pathogenList = getPathogen(record.relationName)
  let keys = []
  let values = []

  if (pathogenList) {
    keys = [...pathogenList.keys()]
    values = [...pathogenList.values()]
  }

  return (
    <div className="ta-c relation-helper-wrapper">
      <Select
        style={{ width: "90%" }}
        placeholder="请选择致病性"
        value={record.pathogen || undefined}
        onChange={onChange}
      >
        {keys.map(
          (key, index) => <Option key={key}>{values[index]}</Option>)
        }
      </Select>
    </div>
  )
})

const ObserverSampleName = observer(({ record, editHistoryList, onChange, onVisibleChange }) => {
  const sampleNameEllipsis = (
    <MaterialTip
      overlayClassName="ellipsis-tip"
      title={record.name}>
      <div className="sample-name ellipsis cursor-p">{record.name}</div>
    </MaterialTip>
  )

  return (
    record.hasHistory
      ? (
        <Row className="cursor-p" type="flex" justify="center" align="middle">
          <WarningTip
            type="warningTip"
            text={sampleNameEllipsis}
            justify="start"
            mainKeys={["versionNum", "sampleName", "createTime"]}
            overlayClassName="ta-c"
            historyData={editHistoryList}
            onVisibleChange={onVisibleChange}
          />
        </Row>
      )
      : record.hasName
        ? (
          <div className="ta-c">
            {sampleNameEllipsis}
          </div>
        )
        : (
          <ObserverInput
            record={record}
            field="sampleName"
            onChange={onChange}
            placeholder="请手动填写样本名"
          />
        )
  )
})
const Observerremark = observer(({ record, onChange }) => {
  return (
    record.hasRemark
      ? (
        <MaterialTip
          title={record.remark}
        >
          <div className="ellipsis ta-c">
            {record.remark}
          </div>
        </MaterialTip>
      )
      : (
        <ObserverInput
          record={record}
          field="remark"
          placeholder="请手动填写备注"
          onChange={onChange}
        />
      )
  )
})

const ObserverOperator = observer(({ record, onClick, index }) => {
  return (
    <Row className="table-oprator" type="flex" justify="center" align="middle">
      <img
        title="恢复"
        src={recoveryIcon}
        className="cursor-p"
        alt=""
        onClick={() => onClick(record, index)}
      />
    </Row>
  )
})

@inject("recycleDetail") @observer
export default class extends Component {
  componentDidMount() {
    const { recycleDetail } = this.props
    recycleDetail.getSamplesRefrenceData()
      .then(() => {
        recycleDetail.loadPrimers()
        recycleDetail.loadRelations()
      }, err => {
        message.error(err.message)
      })
  }

  recoveryData = (record, index) => {
    const { recoveryData, tableData } = this.props.recycleDetail
    recoveryData(record.dataId)
      .then(
        res => {
          tableData.splice(index, 1)
          message.success("数据恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  onSelectChange = (selectedRowKeys) => {
    this.props.recycleDetail.selectedRowKeys = selectedRowKeys
  }

  render() {
    const {
      tableData,
      selectedRowKeys,
      totalPrimers,
      onPrimerSelect,
      onPrimerDeselect,
      onRelationChange,
      onSampleNameChange,
      editHistoryList,
      relations,
      onPathogenChange,
      onInputChange,
    } = this.props.recycleDetail
    
    this.columns = [
      {
        title: <div className="ta-l">文件名称</div>,
        dataIndex: "filename",
        width: "17.34%",
        render: (filename, record, index) => {
          return (
            <FlexableFileName filename={filename} matched={record.matched} />
          )
        }
      }, {
        title: <div className="ta-c">姓名</div>,
        dataIndex: "name",
        width: 80,
        render: (name, sample, index) => {
          return (
            <RequiredStarWrapper>
              <span className='required-star'>*</span>
              <ObserverInput
                record={sample}
                field='name'
                placeholder="请手动填写姓名"
                onChange={(e) => onInputChange(e.target.value, sample, 'name')}
              />
            </RequiredStarWrapper>
          )
        },
      }, {
        title: <div className="ta-c">关系</div>,
        width: 190,
        dataIndex: "relationName",
        render: (relationName, sample, index) => (
          <ObserverRelationSelector
            record={sample}
            relations={relations}
            onChange={(relationId) => onRelationChange(relationId, sample)}
          />
        )
      }, {
        title: <div className="ta-c">致病性</div>,
        width: 180,
        dataIndex: "pathogen",
        render: (relationName, sample, index) => (
          <ObserverPathogenSelector
            record={sample}
            onChange={(key) => onPathogenChange(key, sample)}
          />
        )
      },  {
        title: <div className="ta-c">上传日期</div>,
        dataIndex: "uploadTime",
        width: 90,
        sorter: (a, b) => new Date(a.uploadTime) - new Date(b.uploadTime),
        render: (text) =>
          <div style={{ whiteSpace: 'pre-line' }} className="ta-c">{text.replace(' ', '\n')}</div>
      }, {
        title: <div className="ta-c">Code</div>,
        dataIndex: "fileStatus",
        width: 90,
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text?text:'-'}
          </div>
        ),
      },{
        title: <div className="ta-c">操作</div>,
        dataIndex: "operator",
        width: 80,
        render: (text, record, index) => (
          <ObserverOperator
            record={record}
            index={index}
            onClick={this.recoveryData}
          />
        )
      }
    ]

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    }

    return (
      <div>
        <div className="wrapper-box">
          <Row type="flex" justify='start' align='middle' className='subtitle'>
            <i></i>
            <div>数据列表</div>
            <div className="promotion">注：在关系中显示同一颜色角色表示数据为同一人</div>
          </Row>
          <Table
            className="datamanage-detail-table"
            rowSelection={rowSelection}
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={[...tableData]}
            pagination={false}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/recycle_detail/containers/DataTable.js